import React from "react";
import { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { useI18n } from "../../lib/i18n/i18n_provider";
import { Order, OrderableType } from "../api";
import { TemplateOfferingConfirmOrderDailyAccess } from "../template_offering_confirm_order_daily_access";
import { Text } from "../text";
import { TextLink } from "../text_link";
import { useWeWorkAnalytics } from "./wework_analytics";
import { useWeWorkPartnerConfig } from "./wework_partner_config";

const Theme = lazyWithRetry(() => import("./wework_theme"));

export function OfferingWeWorkConfirmOrderDailyAccess() {
  const { locale } = useI18n();
  const partnerConfig = useWeWorkPartnerConfig();
  useWeWorkAnalytics();
  return (
    <Fragment>
      <Theme />
      <TemplateOfferingConfirmOrderDailyAccess
        partnerConfig={partnerConfig}
        confirmationMessage={(order, orderItem) =>
          orderItem?.type === OrderableType.AddOn ? (
            locale.baseLanguageTag === "he" ? (
              <ConfirmationMessageMultiPassHE order={order} />
            ) : (
              <ConfirmationMessageMultiPassEN order={order} />
            )
          ) : locale.baseLanguageTag === "he" ? (
            <ConfirmationMessageDayPassHE order={order} />
          ) : (
            <ConfirmationMessageDayPassEN order={order} />
          )
        }
      />
    </Fragment>
  );
}

interface ConfirmationMessageProps {
  order: Order;
}

function ConfirmationMessageDayPassEN(props: ConfirmationMessageProps) {
  const { order } = props;

  return (
    <Text>
      Thank you for booking with us. A confirmation email has been sent to{" "}
      {order.email}. We are looking forward to seeing you soon.
    </Text>
  );
}

function ConfirmationMessageMultiPassEN(props: ConfirmationMessageProps) {
  const { order } = props;

  return (
    <Text>
      Thank you for booking with us. A confirmation email has been sent to{" "}
      {order.email}. We are looking forward to seeing you soon.{" "}
      <TextLink href="/portal/wework">Start managing your bookings.</TextLink>
    </Text>
  );
}

function ConfirmationMessageDayPassHE(props: ConfirmationMessageProps) {
  const { order } = props;

  return (
    <Text>
      תודה על ביצוע ההזמנה. ברגעים אלה נשלח אישור לכתובת {order.email}. נתראה
      בקרוב!
    </Text>
  );
}

function ConfirmationMessageMultiPassHE(props: ConfirmationMessageProps) {
  const { order } = props;

  return (
    <Text>
      תודה על ביצוע ההזמנה. ברגעים אלה נשלח אישור לכתובת {order.email}. נתראה
      בקרוב.{" "}
      <TextLink href="/portal/wework">
        לחצו כאן לניהול הזמנות ושריון ימי עבודה
      </TextLink>
    </Text>
  );
}
